import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPassword } from "../../api/services/authService";
import { emailError, passwordError } from "../../utils/validation";
import AuthLayout from "./AuthLayout";
import { AuthField, PasswordField } from "./AuthField";

function ResetPassword() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [email, setEmail] = useState(state?.email || "");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (emailError(email)) return setMessage(emailError(email));
    if (!/^\d{6}$/.test(code.trim())) return setMessage("Enter the 6-digit reset code.");
    if (passwordError(password)) return setMessage(passwordError(password));
    if (password !== confirm) return setMessage("Passwords do not match.");
    setBusy(true);
    try {
      await resetPassword({ email: email.trim(), code: code.trim(), password, confirmPassword: confirm });
      navigate("/login", { replace: true, state: { reset: true } });
    } catch (err) {
      setMessage(err.details?.fields?.code || err.message || "Unable to reset the password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Reset Password" subtitle="Enter the code we sent you and choose a new password." footer={<button type="button" className="auth-link" onClick={() => navigate("/login")}>Back to Login</button>}>
      <form onSubmit={submit} noValidate>
        {!state?.email && <AuthField label="Email address" icon="bi-envelope" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" autoComplete="email" />}
        <AuthField label="Reset code" icon="bi-shield-check" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="6-digit code" inputMode="numeric" autoComplete="one-time-code" />
        <PasswordField label="New password" value={password} onChange={e => setPassword(e.target.value)} placeholder="New Password" autoComplete="new-password" />
        <PasswordField label="Confirm password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Confirm Password" autoComplete="new-password" />
        {message && <div className="auth-error" role="alert">{message}</div>}
        <button className="auth-primary" disabled={busy}>{busy ? "Resetting…" : "Reset Password"}</button>
      </form>
    </AuthLayout>
  );
}
export default ResetPassword;
